/* unplugin-vue-components disabled */import script from "./AddAccountModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddAccountModal.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__